import { SimpleModalComponent } from './simple-modal.component';
import {SuiModal, ComponentModalConfig, ModalSize} from "ng2-semantic-ui";
import { IConfirmModalContext} from '../../core/models/confirmModalcontext.interface';

export class SimpleModal extends ComponentModalConfig<IConfirmModalContext, void, void> {
    constructor(title: string, question: string, size = ModalSize.Large) {
        super(SimpleModalComponent, { title, question });
        this.isClosable = false;
        this.transitionDuration = 200;
        this.size = size;
    }
}